
import { bestPicFormat } from '@/assets/scripts/utils'

export default {
  name: 'ApiEnumBlock',
  props: {
    apiData: { type: Object, default: () => {} },
  },
  created() {
    this.bestPicFormat = bestPicFormat
  },
}
